import(/* webpackMode: "eager" */ "/app/apps/web-tms/src/app/global-error.tsx");
